import { APIClient } from '@lifeomic/one-query';
import { Endpoints as PatientServiceEndpoints } from '@lifeomic/service-clients/patient-service';
import {
  type FhirAPIEndpoints,
  FHIR_API_HOOKS_NAME,
  useFHIRQuery,
  useInfiniteFHIRQuery,
  useFHIRMutation,
  useFHIRCombinedQueries,
  useFHIRCache,
  useFhirClient,
  useDataset,
} from '@lifeomic/phc-web-toolkit/src/util/api';
import getOneQueryClient from './oneQueryClient';

export type { FhirAPIEndpoints };
export {
  FHIR_API_HOOKS_NAME,
  useFHIRQuery,
  useInfiniteFHIRQuery,
  useFHIRMutation,
  useFHIRCombinedQueries,
  useFHIRCache,
  useFhirClient,
  useDataset,
};

type Endpoints = FhirAPIEndpoints & PatientServiceEndpoints;

/**
 * Raw axios client for ad-hoc `/api` requests (non-one-query).
 * Auth is read from the app redux store on each request.
 */
export const client = getOneQueryClient({ urlPrefix: '/api' });

/**
 * Typed FHIR + patient-service client backed by the app redux auth singleton.
 * Prefer `useFhirClient` in new React code so auth tracks account switches.
 */
export const fhirClient = new APIClient<Endpoints>(client);
